import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { createLogger, DEBUG, INFO } from 'browser-bunyan';
import { ServerStream } from '@browser-bunyan/server-stream';
import { ServerLoggerConfig } from '~shared/modules/server-logger/models/server-logger-config.interface';
import { ServerLoggerConfigToken } from '~shared/modules/server-logger/tokens/server-logger.token';
import { isPlatformBrowser } from '@angular/common';

@Injectable()
export class ServerLoggerService {
  private readonly logger;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(ServerLoggerConfigToken) private readonly serverLoggerConfig: ServerLoggerConfig
  ) {
    if(isPlatformBrowser(this.platformId)) {
      this.logger = createLogger({
        name: 'serverLogger',
        level: serverLoggerConfig.logLevel,
        stream: new ServerStream({
          url: serverLoggerConfig.logEndpoint,
          method: serverLoggerConfig.httpMethod,
        }),
      });
    }
  }

  public debug(message: string, context: object = null) {
    this.logger.debug({ context }, message);
  }

  public info(message: string, context: object = null) {
    this.logger.info({ context }, message);
  }

  public warning(message: string, context: object = null) {
    this.logger.warn({ context }, message);
  }

  public error(message: string, context: object = null) {
    this.logger.error({ context }, message);
  }
}
